const actions = {
	SET_GROUP: "SET_GROUP"
};

export default actions;
